"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePickerDropZone = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FilePicker_styles_1 = require("./FilePicker.styles");

var FilePickerDropZone = function FilePickerDropZone(_ref) {
  var getRootProps = _ref.getRootProps,
      getInputProps = _ref.getInputProps;
  return react_1.default.createElement("div", Object.assign({
    className: FilePicker_styles_1.DROPZONE_STYLES.wrapper
  }, getRootProps()), react_1.default.createElement("input", Object.assign({}, getInputProps())), react_1.default.createElement("div", {
    className: FilePicker_styles_1.DROPZONE_STYLES.title
  }, "Select Files to Upload"), react_1.default.createElement("div", {
    className: FilePicker_styles_1.DROPZONE_STYLES.description
  }, "or Drag and Drop, Copy and Paste Files "));
};

exports.FilePickerDropZone = FilePickerDropZone;